<template>
  <div class="page-survey-entry">
    <div class="inner">
      <strong v-show="loading">
        载入中
      </strong>
      <template v-if="!loading && _bgImg">
        <img :src="_bgImg"
          alt="Loading...">
      </template>
    </div>

    <template v-if="baseInfo && baseInfo.cpCode && isShowBg">
      <!-- START -->
      <router-link :to="`/survey/mine?code=${code}`">
        <a href="javascript:;"
          class="global-entry-records">
          测评<br>
          记录
        </a>
      </router-link>
      <router-link :to="`/survey/chat?code=${code}`">
        <span class="entry-start">
          开始测评
        </span>
      </router-link>
    </template>
  </div>
</template>

<script>
import { injectMixins } from '@/services'
import { isWeixin, setupWXShare } from '@/helpers'

export default {
  name: 'PageSurveyMainEntry',

  mixins: [
    injectMixins
  ],

  data () {
    return {
      isShowBg: false,
      loading: false
    }
  },

  async created () {
    try {
      this.loading = true
      await this._ensureCpCode()
      await this._ensureBaseInfo()
      // region 跳转到最近一条测评 // wechat only
      // const isFromAppMessage = this.$route.query.from === 'message'

      // if (isWeixin()) {
      //   const firstMeasurent = await this.firstMeasurentNo()

      //   if (firstMeasurent) {
      //     this.gState.tmpChatResult = firstMeasurent
      //     await this.$router.replace(`/survey/detail?key=${firstMeasurent.assessNO}&code=${this.code}`)
      //     return
      //   }
      // }
      // endregion
      // app微信分享
      const isApp = window.location.href.includes('one-sandbox')
      if (isApp) {
        const baseInfo = this.gState.tmpSurveyBaseInfo
        setupWXShare(baseInfo)
      }

      const isShowBg = this.baseInfo && (+this.baseInfo.isShow === 1)

      if (!isShowBg) {
        await this.$router.replace(`/survey/chat?code=${this.code}`)
        return
      }

      this.isShowBg = isShowBg
    } finally {
      this.loading = false
    }
  },

  mounted () {
    this.$watch('baseInfo', (baseInfo) => {
      if (!baseInfo) return
      document.title = (baseInfo.name || '壹零医')
    }, {
      immediate: true
    })
  },

  computed: {
    _innerStyle () {
      const obj = {}
      // if (
      //   this.isShowBg &&
      //   this.baseInfo.image
      // ) {
      //   // obj.backgroundImage = 'url("http://101onlinetest.doctopia.com.cn/2020_1_15_qss_2_lwbyzarm.jpg")' //`url('${this.baseInfo.image}')`
      //   // obj.backgroundImage = `url('${this.baseInfo.image}')`
      // }

      return obj
    },

    _bgImg () {
      return this.isShowBg && this.baseInfo.image
    }
  },

  methods: {
    async firstMeasurentNo () {
      try {
        const res = await this.gActions.getMineSurveyList(this.code)
        return res.length > 0 && res[0]
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss">
.page-survey-entry {
  > .inner {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    min-height: 100vh;
    flex-direction: column;

    background-color: white;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: top center;

    > strong {
      color: #a6a8b6;
      font-weight: normal;
      width: 100%;
      text-align: center;
    }

    > img {
      width: 100%;
    }
  }

  .entry-start {
    position: absolute;
    bottom: 16px;
    left: 50%;
    z-index: 1;
    height: 42px;
    width: 92%;
    transform: translateX(-50%);
    border-radius: 10vw;

    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    background-color: #3dd3cb;
    box-shadow: 0 1px 10px 0 rgba(108, 134, 181, 0.15);
    letter-spacing: 1px;
    font-size: 16px;
  }

  .entry-start,
  .global-entry-records {
    outline: none;
  }
}
</style>
